import React from "react";

const GooglePay = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={17}
      viewBox="0 0 40 17"
      {...props}
    >
      <title>{"GooglePay"}</title>
      <path
        d="M18.95 8.321v4.66h-1.435V1.479h3.805a3.354 3.354 0 012.459 1 3.391 3.391 0 01.161 4.7l-.161.165a3.393 3.393 0 01-2.459.981zm0-5.43v4.018h2.405a1.851 1.851 0 001.417-.6 2.066 2.066 0 00-.044-2.853 1.93 1.93 0 00-1.373-.569zm9.169 1.963a3.526 3.526 0 012.512.871 3.146 3.146 0 01.918 2.4v4.852h-1.372V11.89h-.063a2.724 2.724 0 01-2.37 1.348 3.022 3.022 0 01-2.111-.771 2.461 2.461 0 01-.847-1.926 2.375 2.375 0 01.9-1.944 3.682 3.682 0 012.4-.725 4.222 4.222 0 012.1.477v-.34A1.746 1.746 0 0029.6 6.7a2.05 2.05 0 00-1.381-.541 2.166 2.166 0 00-1.9 1.045l-1.266-.816a3.442 3.442 0 013.066-1.534zm-1.854 5.715a1.2 1.2 0 00.472.963 1.72 1.72 0 001.114.385 2.249 2.249 0 001.613-.688 2.2 2.2 0 00.713-1.623 2.813 2.813 0 00-1.871-.542 2.434 2.434 0 00-1.462.431 1.3 1.3 0 00-.579 1.074zm13.161-5.458l-4.794 11.328h-1.479l1.782-3.962-3.145-7.366h1.559l2.272 5.65h.027l2.219-5.65z"
        fill="#343146"
      />
      <path
        d="M13.149 7.312a8.426 8.426 0 00-.107-1.339h-6.05v2.541h3.466a3.07 3.07 0 01-1.283 2.009v1.651h2.067a6.541 6.541 0 001.907-4.862z"
        fill="#4285f4"
      />
      <path
        d="M6.992 13.77a6.033 6.033 0 004.25-1.6l-2.067-1.647a3.769 3.769 0 01-2.183.633 3.853 3.853 0 01-3.6-2.725h-2.13v1.707a6.394 6.394 0 005.73 3.632z"
        fill="#34a853"
      />
      <path
        d="M3.392 8.431a4.1 4.1 0 010-2.531V4.2h-2.13a6.724 6.724 0 000 5.925z"
        fill="#fbbc04"
      />
      <path
        d="M6.992 3.175a3.4 3.4 0 012.459.991l1.836-1.889A6.1 6.1 0 006.992.561 6.4 6.4 0 001.262 4.2l2.13 1.706a3.85 3.85 0 013.6-2.731z"
        fill="#ea4335"
      />
    </svg>
  );
};

export default GooglePay;
